import { Component, effect, inject } from '@angular/core';
import {
	CustomerActionEnum,
	CustomerRecordDto,
	CustomerStatusEnum,
	customerStatusToColor,
	customerValidators,
} from '@splitsecondconnect/ultramarine-shared';
import { take } from 'rxjs';

import { BaseMenuPortalButtonComponent } from '../../../../../shared/base-classes/base-menu-portal-button.component';
import { ListItemMenuContainerComponent } from '../../../../../shared/components/containers/list-item-menu-container/list-item-menu-container.component';
import { UltraActionsNavigationComponent } from '../../../../../shared/components/ultramarine-ui/ultra-actions-navigation/ultra-actions-navigation.component';
import { UltraMenuItemComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item/ultra-menu-item.component';
import { UltraMenuItemWrapperComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item-wrapper/ultra-menu-item-wrapper.component';
import { UltraNavigationItem } from '../../../../../shared/models/ultra-navigation-item.model';
import { RecordEventsService } from '../../../../../shared/services/record-events.service';
import { CustomersService } from '../../customers.service';

@Component({
	selector: 'app-customer-status-button',
	templateUrl: 'customer-status-button.component.html',
	imports: [
		UltraMenuItemWrapperComponent,
		UltraMenuItemComponent,
		ListItemMenuContainerComponent,
		UltraActionsNavigationComponent,
	],
})
export class CustomerStatusButtonComponent extends BaseMenuPortalButtonComponent<CustomerRecordDto> {
	private _customersService = inject(CustomersService);
	private _recordEventsService = inject(RecordEventsService);

	public menuData: UltraNavigationItem[] = [];
	constructor() {
		super();
		effect(() => {
			if (this.isEditMode()) {
				return;
			}
			this._customersService.getRecord(this.id()).subscribe();
		});
		this._customersService.record$.subscribe((res) => {
			this.recordDataDtoSignal.set(res?.data);
		});
		effect(() => {
			if (!this.recordDataDtoSignal()) {
				return;
			}
			this.menuData = [
				{
					title: 'customers|status|active',
					color: customerStatusToColor(CustomerStatusEnum.ACTIVE),
					type: 'basic',
					icon: 'check',
					disabled: !this._canPerformAction(CustomerActionEnum.ACTIVATE),
					function: () => {
						this._executeStatusAction(CustomerStatusEnum.ACTIVE);
					},
				},
				{
					title: 'customers|status|on-hold',
					color: customerStatusToColor(CustomerStatusEnum.ON_HOLD),
					type: 'basic',
					icon: 'pause',
					disabled: !this._canPerformAction(CustomerActionEnum.PUT_ON_HOLD),
					function: () => {
						this._executeStatusAction(CustomerStatusEnum.ON_HOLD);
					},
				},
				{
					title: 'customers|status|closed',
					color: customerStatusToColor(CustomerStatusEnum.CLOSED),
					type: 'basic',
					icon: 'close',
					disabled: !this._canPerformAction(CustomerActionEnum.CLOSE),
					function: () => {
						this._executeStatusAction(CustomerStatusEnum.CLOSED);
					},
				},
			];
		});
	}
	protected _canPerformAction(action: CustomerActionEnum): boolean {
		const validationResult = customerValidators.canPerformAction(
			this.recordDataDtoSignal(),
			action,
		);
		return validationResult.isValid;
	}

	private _executeStatusAction(status: CustomerStatusEnum) {
		this.modalsService.dismissTopModal();
		const recordDto = this.recordDataDtoSignal();
		recordDto.status = status;
		this._customersService
			.updateRecordStatus(recordDto.id, recordDto.status)
			.pipe(take(1))
			.subscribe(() => {
				this._recordEventsService.onTaskUpdateSubmitted.next(null);
			});
	}
}
